import {Component, OnInit} from '@angular/core';
import {OwlOptions} from "ngx-owl-carousel-o";
import {PortalService} from "../../core/web/portal-service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-specialties-section',
  templateUrl: './specialties-section.component.html',
  styleUrl: './specialties-section.component.scss'
})
export class SpecialtiesSectionComponent implements OnInit {

  protected specialitiesList: Array<any> | undefined;

  constructor(
      private portalService: PortalService,
      private router: Router
  ) {
  }

  ngOnInit(): void {
    this.onLoadSpecialties();
  }

  onLoadSpecialties(): void {
    this.portalService.getSpecialities().subscribe(response => this.specialitiesList = response);
  }

  onSearchBySpeciality(code) {
    this.router.navigate(['portail/search'], {queryParams: {speciality: code}});
  }

  public specialitiesSlider: OwlOptions = {
    loop: true,
    margin: 24,
    dots: false,
    nav: true,
    smartSpeed: 2000,
    navText: [
      '<i class="fas fa-chevron-left"></i>',
      '<i class="fas fa-chevron-right"></i>',
    ],
    responsive: {
      0: {
        items: 1
      },
      500: {
        items: 1
      },
      768: {
        items: 2
      },
      1000: {
        items: 6
      },
      1200: {
        items: 6
      },
    },
  };
}
